export interface FormData {
  // Qualification
  debtAmount: number | null
  debtAmountRaw: number | null  // Slider value (0-380)
  income: string | null         // Stored as string like '5500', '2500', '0'

  // PII
  firstName: string
  lastName: string
  email: string
  phone: string
  phoneUnmasked: string
  address: string
  city: string
  state: string
  zip: string
  dobMonth: string
  dobDay: string
  dobYear: string

  // Tracking
  ipAddress: string
  jornayaLeadId: string
  trustedFormId: string
  trustedFormUrl: string
  tcpaLanguage: string

  // Array credit data
  arrayCredit: string | null
  arrayDebt: string | null
  arrayCollections: string | null
  arrayDelinquencies: string | null
  arrayTaxLiens: string | null
  arrayStudentLoans: string | null
  verifiedDebt: number

  // Lead post result
  advertiserId: string
  revenue: number
  redirectUrl: string
}

export interface ValidationState {
  email: FieldValidation
  phone: FieldValidation
}

export interface FieldValidation {
  valid: boolean | null
  checking: boolean
  error: string | null
  sendToAC?: boolean
}

export function createInitialFormData(): FormData {
  return {
    debtAmount: null,
    debtAmountRaw: null,
    income: null,
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    phoneUnmasked: '',
    address: '',
    city: '',
    state: '',
    zip: '',
    dobMonth: '',
    dobDay: '',
    dobYear: '',
    ipAddress: '',
    jornayaLeadId: '',
    trustedFormId: '',
    trustedFormUrl: '',
    tcpaLanguage: '',
    arrayCredit: null,
    arrayDebt: null,
    arrayCollections: null,
    arrayDelinquencies: null,
    arrayTaxLiens: null,
    arrayStudentLoans: null,
    verifiedDebt: 0,
    advertiserId: '',
    revenue: 0,
    redirectUrl: '',
  }
}
